"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageKeys = {
    ModuleIds: 'moduleIds',
    AccessRightIds: 'accessRightIds',
    IsExternalToken: 'is-external-token',
    UserProfile: 'userProfile',
    CultureName: 'cultureName'
};
